import { useQuery } from "@tanstack/react-query";
import { BriefService } from "../services/brief.service";
import { BRIEF_FACETS_QUERY_KEY } from "../constants";
import { useEffect } from "react";
import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import { IBriefFacets } from "@shared/lib/types/brief";

export function useGetBriefFacets() {
  const { data, isError, isLoading, error } = useQuery<
    BackednResponse<IBriefFacets>
  >({
    queryKey: [...BRIEF_FACETS_QUERY_KEY],
    queryFn: () => BriefService.getBriefFacets(),
  });

  const errorMessage = isError && error?.message;
  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    facets: data?.data,
    isFetching: isLoading,
  };
}
